import { CarouselModel } from "src/models/carousel";
import { ApiService } from "../apiService";
import { FAQModel } from "src/models/faq";
import { TestimonialModel } from "src/models/testimonial";
import { PartnerModel } from "src/models/partner";
import { SubServiceModel } from "src/models/subService";
import { ServiceModel } from "src/models/service";
import { AdminReportModel } from "src/models/adminReport";
import { UserInfo } from "src/models/userInfo";
import { doctorCustomReportsModel } from "src/models/doctorCustomReports";
import { DoctorProfileModel } from "src/models/doctorProfile";

const apiService = new ApiService();

export const deleteBannerById = async (id: string) => await apiService.post<CarouselModel>(`Admin/DeleteCarousel?id=${id}`, {});

export const createBanner = async (data: FormData) => await apiService.post<CarouselModel>(`Admin/CreateCarousel`,
    data, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}
);

export const updateBanner = async (data: FormData) => await apiService.post<CarouselModel>(`Admin/UpdateCarousel`,
    data, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}
);

export const deleteFaqById = async (id: string) => await apiService.post<FAQModel>(`Admin/DeleteFaq?id=${id}`, {});

export const createFaq = async (data:any) => await apiService.post<FAQModel>(`Admin/CreateFaq`,
    data
);

export const updateFaq = async (data: any) => await apiService.post<FAQModel>(`Admin/UpdateFaq`,
    data
);

export const createTestimonial = async (data: FormData) => await apiService.post<TestimonialModel>(`Admin/CreateTestimonial`,
    data, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}
);

export const updateTestimonial = async (data: FormData) => await apiService.post<TestimonialModel>(`Admin/UpdateTestimonial`,
    data, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}
);

export const deleteTestimonialById = async (id: string) => await apiService.post<TestimonialModel>(`Admin/DeleteTestimonial?id=${id}`, {});

export const createPartner = async (data: FormData) => await apiService.post<PartnerModel>(`Admin/CreatePartner`,
    data, {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}
);

export const deletePartnerById = async (id: string) => await apiService.post<PartnerModel>(`Admin/DeletePartner?id=${id}`, {});

export const createSubService = async (data:any) => await apiService.post<SubServiceModel>(`Admin/CreateSubService`,
    data
);

export const updateSubService = async (data: any) => await apiService.post<SubServiceModel>(`Admin/UpdateSubService`,
    data
);

export const deleteSubServiceById = async (id: string) => await apiService.post(`Admin/DeleteSubService?id=${id}`, {});

export const saveService = async(data: ServiceModel)=>{
    const formData = new FormData();
        formData.append('name', data.title ?? "");
        formData.append('description', data.description ?? "");
        formData.append('cost', data.cost?.toFixed(2) ?? "");
        formData.append('image', data.image ?? "");
        formData.append('isQuestionary', data.isQuestionary.toString());
        formData.append('questions', data.questions ?? "");
        if(data.isActive){
            formData.append('isActive', (data.isActive).toString());
        }else{
            formData.append('isActive', (true).toString());
        }
        if (data.imageFile && data.imageFile instanceof File) {
            formData.append('imageFile', data.imageFile);
        }
        if(data.id== null){
            let result = await apiService.post<ServiceModel>(`Admin/CreateService`,data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return result;
        }else{
            formData.append('id', data.id.toString());
            let result = await apiService.post<ServiceModel>(`Admin/UpdateService`,data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return result;
        }
}
export const getAllDoctors = async () => await apiService.get<UserInfo[]>(`SuperAdmin/GetDoctorProfile`);

export const deleteProfile = async(id:any) => await apiService.post(`SuperAdmin/DeleteProfile?id=${id}`,{});
export const getReport = async () => apiService.get<AdminReportModel[]>(`Admin/GetAllConsultantReport`);

export const getAllPendingProfileEdits = async () =>
    await apiService.get(`Admin/GetAllPendingProfileEdits`);
  
  export const getDoctorEditDetails = async (editId: string) =>
    await apiService.get(`Admin/GetDoctorEditDetails?editId=${editId}`);
  
 export const approveDoctorProfileEdit = async (formData: FormData) => { 
  return await apiService.post( "Admin/ApproveDoctorProfileEdit",
     formData, { headers: { "Content-Type": "multipart/form-data", }, } ); };

  export const getAllCustomEdit = async () => await apiService.get<UserInfo[]>(`Admin/edit-profile`);

  export const getAllCustomReport = async () => await apiService.get<UserInfo[]>(`Admin/report`);
    export const getAllNewDoctors = async () => await apiService.get<UserInfo[]>(`Admin/newdoctors`);


  export const approveDoctorEdits = async (doctorId: string) =>
    await apiService.post(`Admin/approve-doctor-edits/${doctorId}`, {});

  export const generateDoctorReport = async (
    userId: string | number,
    fromDate: number,
    toDate: number
  ) =>
    await apiService.get<doctorCustomReportsModel[]>(
      `Admin/generate-doctor-report/${userId}/${fromDate}/${toDate}`
    );
export const ViewDoctorById = async (userId: string) =>await apiService.get<DoctorProfileModel>(`Doctor/GetDoctorById?id=${userId}`);
export const updateDoctor = async (formData: FormData, role: string, actionType: string) => {
  return await apiService.post(
    `Doctor/UpdateDoctor?role=${role}&actionType=${actionType}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const rejectDoctorProfileEdit = async (editId: string, reason: string) => {
  return await apiService.post(`Admin/RejectDoctorProfileEdit`, {
    editId,
    reason
  });
};
export const updateDoctorProcessStatus = async (userId: number, status: string) => {
  const response = await apiService.post(`Doctor/UpdateDoctorProcessStatus`, {
    userId,
    status,
  });
  return response;
};
